import { Browser } from "@capacitor/browser";
import { openURL, Platform } from "quasar";

export default function openUrl(url: string) {
  if (Platform.is.capacitor) {
    Browser.open({ url });
  } else {
    openURL(url);
  }
}
